var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { Service } from '~/core/service';
var PeriodTransformService = /** @class */ (function (_super) {
    __extends(PeriodTransformService, _super);
    function PeriodTransformService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PeriodTransformService.prototype.getAllTransformTemplate = function (data, page, loading) {
        return this.netService.send({
            server: managementService.periodTransformController.getAllTransformTemplate,
            data: data,
            page: page,
            loading: loading
        });
    };
    /*
   * 新建模板
   */
    PeriodTransformService.prototype.createTransformTemplate = function (data, loading) {
        return this.netService.send({
            server: managementService.periodTransformController.createTransformTemplate,
            data: {
                tramsformMap: data.tramsformMap,
                principalId: data.principalId,
                principalName: data.principalName,
            },
            loading: loading
        });
    };
    /**
     * 修改模板配置
     */
    PeriodTransformService.prototype.modifyTransformTemplate = function (data, loading) {
        return this.netService.send({
            server: managementService.periodTransformController.modifyTransformTemplate,
            data: {
                id: data.id,
                tramsformMap: data.tramsformMap,
                principalId: data.newprincipalId,
                principalName: data.principalName,
            },
            loading: loading
        });
    };
    /**
    * 删除模板
    */
    PeriodTransformService.prototype.deleteTemplateById = function (id, loading) {
        return this.netService.send({
            server: managementService.periodTransformController.deleteTemplateById,
            data: {
                id: id,
            },
            loading: loading
        });
    };
    /**
     * 获取指定委托方配置
     */
    PeriodTransformService.prototype.getPrincipalTransformTemplate = function (data) {
        return this.netService.send({
            server: managementService.periodTransformController.getPrincipalTransformTemplate,
            data: {
                principalId: data.principalId
            }
        });
    };
    __decorate([
        Inject(NetService)
    ], PeriodTransformService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], PeriodTransformService.prototype, "createTransformTemplate", null);
    __decorate([
        Debounce()
    ], PeriodTransformService.prototype, "modifyTransformTemplate", null);
    __decorate([
        Debounce()
    ], PeriodTransformService.prototype, "deleteTemplateById", null);
    return PeriodTransformService;
}(Service));
export { PeriodTransformService };
